import { render, staticRenderFns } from "./SmartformSidebar.vue?vue&type=template&id=585fc029&scoped=true"
import script from "./SmartformSidebar.vue?vue&type=script&lang=js"
export * from "./SmartformSidebar.vue?vue&type=script&lang=js"
import style0 from "./SmartformSidebar.vue?vue&type=style&index=0&id=585fc029&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585fc029",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VSlideXTransition } from 'vuetify/lib/components/transitions';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VCheckbox,VIcon,VList,VSlideXTransition,VTab,VTabs})
